var render = function (_h,_vm) {var _c=_vm._c;return _c('h1',{staticClass:"base-title truncate-ellipsis",class:[_vm.data.class, _vm.data.staticClass]},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.props.text)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }